export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Toolbar.vue?vue&type=template&id=9334526a&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/whiteboard/Toolbar.vue?vue&type=template&id=9334526a&
// module id = null
// module chunks = 